import * as React from 'react';
import { Card, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';


const StyledIcon = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: 'center',
}));

const DataCard = ({ item, itemValue, color, colorLight, colorHover, icon, isShareable, handleShareLink, fullQuery }) => {

const handleClick = () => {
  if (isShareable){
    handleShareLink(item,fullQuery);
  }
};


  return (
  	<Card
      sx={{
        pt: 0.5,
        boxShadow: 0,
        textAlign: 'center',
        border: "2px solid "+colorLight,
        color: (theme) => color,
        bgcolor: (theme) => colorLight,
        height: '90px',
        ...(isShareable && {
          '&:hover': {
            border: "2px solid "+color,
            backgroundColor: colorHover,
          },
        }),
      }}
      onClick={handleClick}
    >
    <StyledIcon
          sx={{
            color: (theme) => 'white',
            backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(colorLight, 0)} 0%, ${alpha(color,0.9)} 100%)`,
          }}
        >
          {icon}
        </StyledIcon>
        <Typography variant="h6">{itemValue}</Typography>
        <Typography variant="subtitle2">{item}</Typography>`
    </Card>
  );
}

export default DataCard;
